import React, { useState } from "react"
import { createPortal } from "react-dom"
import PageWrapper from "Pages/@PageWrapper"
import { EUROPCAR_ROUTES } from "@constants/routes"
import EuropcarAnalyticsContent from "Pages/BusinessLogistics/Analytics/Page/Content"
import VirtualTourButton, { TourOverlay, TOUR_STEPS } from "./VirtualTour"
import AnalyticsDemoData from "./VirtualTour/DemoData"


export default function EuropcarAnalyticsPage() {
	const [tourActive, setTourActive] = useState(false)

	return <PageWrapper
		head={`DS Rentacar | ${EUROPCAR_ROUTES.TITLE}`}
		title={EUROPCAR_ROUTES.TITLE}
		subtitle={EUROPCAR_ROUTES.ANALYTICS_SUBTITLE}
		isEmpty={false}
		actions={<VirtualTourButton onClick={() => setTourActive(true)} />}
	>
		<EuropcarAnalyticsContent/>
		{tourActive && <AnalyticsDemoData />}
		{tourActive && createPortal(
			<TourOverlay steps={TOUR_STEPS} onClose={() => setTourActive(false)} />,
			document.body
		)}
	</PageWrapper>
}
